import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "periodSelect",
    "morningFields",
    "afternoonFields",
    "morningStartInput",
    "morningEndInput",
    "afternoonStartInput",
    "afternoonEndInput"
  ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const period = this.periodSelectTarget.value

    if (period === "am") {
      this.showMorningOnly()
    } else if (period === "pm") {
      this.showAfternoonOnly()
    } else if (period === "day") {
      this.showBoth()
    }
  }

  showMorningOnly() {
    this.morningFieldsTarget.classList.remove("hidden")
    this.afternoonFieldsTarget.classList.add("hidden")

    this.enableInputs(this.morningStartInputTarget, this.morningEndInputTarget)
    this.disableInputs(this.afternoonStartInputTarget, this.afternoonEndInputTarget)
  }

  showAfternoonOnly() {
    this.morningFieldsTarget.classList.add("hidden")
    this.afternoonFieldsTarget.classList.remove("hidden")

    this.disableInputs(this.morningStartInputTarget, this.morningEndInputTarget)
    this.enableInputs(this.afternoonStartInputTarget, this.afternoonEndInputTarget)
  }

  showBoth() {
    this.morningFieldsTarget.classList.remove("hidden")
    this.afternoonFieldsTarget.classList.remove("hidden")

    this.enableInputs(
      this.morningStartInputTarget,
      this.morningEndInputTarget,
      this.afternoonStartInputTarget,
      this.afternoonEndInputTarget
    )
  }

  enableInputs(...inputs) {
    inputs.forEach(input => {
      input.removeAttribute("disabled")
      input.required = true
    })
  }

  disableInputs(...inputs) {
    inputs.forEach(input => {
      input.setAttribute("disabled", "disabled")
      input.required = false
    })
  }
}
